/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OfficeName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function OfficeName({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/OfficeName"
  
}) {
let professionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameValueData = fromData.useDataFormat({ viewPath,
context: 'professional',
path: 'employee.provider.employee_resource.employment_contract.organization.name',
format: fromFormat.toTitleCase,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingBottom={dtSpaceXxs}
 size="small"
 textOverflow="ellipsis"
 overflowX="hidden"
 overflowY="hidden"
 whiteSpace="nowrap"
 color={dtColorsNeutral500}
 data="professional.employee.provider.employee_resource.employment_contract.organization.name"
 format="/Data/format.js toTitleCase"
 text={professionalEmployeeProviderEmployeeResourceEmploymentContractOrganizationNameValueData}
/>
{children}
</React.Fragment>)
}